import apiClient from '../api';

export const getAllNewsletters = ( header) => apiClient.get(`/newsletter/all`, header);

export const getNewsletterByOrgId = (id, header) => apiClient.get(`/newsletter/by/org/${id}`, header);